import type { AppDispatch } from "@state/store";
import { logException } from "@helpers/logException/logException";
import { endViewAsSessionOnServer } from "@helpers/viewAs/viewAsEnd";
import { getViewAsSessionId } from "@helpers/viewAs/viewAsSession";
import {
  clearViewAsSession,
  readStoredViewAsSessionId,
} from "@helpers/viewAs/viewAsStorage";
import { viewAsSessionEnded, viewAsSessionEnding } from "./viewAs.reducer";

let exitInFlight = false;

export const exitViewAsSession =
  () =>
  async (dispatch: AppDispatch): Promise<void> => {
    if (exitInFlight) return;
    exitInFlight = true;

    const sessionId = getViewAsSessionId();

    // The tab stops first: no request leaves it while the server is told.
    dispatch(viewAsSessionEnding());

    // Cleared before the server answers: other tabs reconcile at once, a reload cannot rebind; a newer id stays.
    if (sessionId && readStoredViewAsSessionId() === sessionId) {
      clearViewAsSession();
    }

    let endConfirmed = false;
    try {
      endConfirmed = sessionId
        ? await endViewAsSessionOnServer(sessionId)
        : false;
    } catch (exception) {
      // The tab still ends; the screen says the server may not have.
      logException({ tag: "exitViewAsSession", exception });
    } finally {
      exitInFlight = false;
    }

    dispatch(viewAsSessionEnded({ endConfirmed }));
  };
